"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetDetailsReducer = void 0;
var _basePropTypes = require("../types/propTypes/basePropTypes");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var updatePets = function updatePets(state, action, propertyKey) {
  var petNumber = action.petNumber;
  var adjustedPets = action.adjustedPets;
  if (propertyKey) {
    adjustedPets = state.pets.map(function (petDetails, index) {
      if (index === petNumber) {
        return _objectSpread(_objectSpread({}, petDetails), {}, _defineProperty({}, propertyKey, action[propertyKey]));
      }
      return petDetails;
    });
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    pets: adjustedPets
  });
};
var PetDetailsReducer = exports.PetDetailsReducer = {
  'setSpecies': function setSpecies(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      species: action.species
    });
  },
  'setName': function setName(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      petName: action.petName
    });
  },
  'setBirthdate': function setBirthdate(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      petDOB: action.petDOB
    });
  },
  'setGender': function setGender(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      gender: action.gender
    });
  },
  'setDesexed': function setDesexed(state, action) {
    return _objectSpread(_objectSpread({}, state), {}, {
      desexed: action.desexed
    });
  },
  'addAnotherPet': function addAnotherPet(state, action) {
    return {
      owner: state.owner,
      pets: [].concat(_toConsumableArray(state.pets), [_basePropTypes.emptyPetDetails])
    };
  },
  'savePet': function savePet(state, action) {
    return updatePets(state, action);
  },
  'setPetSpecies': function setPetSpecies(state, action) {
    return updatePets(state, action, 'species');
  },
  'setPetName': function setPetName(state, action) {
    return updatePets(state, action, 'petName');
  },
  'setPetBirthdate': function setPetBirthdate(state, action) {
    return updatePets(state, action, 'petDOB');
  },
  'setPetGender': function setPetGender(state, action) {
    return updatePets(state, action, 'gender');
  },
  'setPetDesexed': function setPetDesexed(state, action) {
    return updatePets(state, action, 'desexed');
  }
};